import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgShareSocialOutline = function SvgShareSocialOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 2C14.7909 2 13 3.79086 13 6C13 6.41005 13.0617 6.80569 13.1763 7.17815L9.11967 9.49624C8.38653 8.58393 7.26146 8 6 8C3.79086 8 2 9.79086 2 12C2 14.2091 3.79086 16 6 16C7.26154 16 8.38667 15.416 9.1198 14.5036L13.1764 16.8216C13.0617 17.1942 13 17.5899 13 18C13 20.2091 14.7909 22 17 22C19.2091 22 21 20.2091 21 18C21 15.7909 19.2091 14 17 14C15.7385 14 14.6134 14.5839 13.8803 15.4963L9.82366 13.1782C9.9383 12.8057 10 12.4101 10 12C10 11.5899 9.93827 11.1941 9.8236 10.8216L13.8802 8.50357C14.6133 9.41599 15.7385 10 17 10C19.2091 10 21 8.20914 21 6C21 3.79086 19.2091 2 17 2Z"
  })));
};

export { SvgShareSocialOutline as ReactComponent };
//# sourceMappingURL=share-social_outline.svg.js.map
